import Menu from "Components/menu";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { ITEM_SIZES, SidebarMenuList } from "Areas/Sidebar/Common";
import buildRunMethodsError from "Areas/Sidebar/DocumentsFloat/utils/buildRunMethodsError";
import buildScriptActionsMenuItems from "Areas/Sidebar/DocumentsFloat/utils/buildScriptActionsMenuItems";
import buildScriptSidebarItems from "Areas/Sidebar/DocumentsFloat/utils/buildScriptSidebarItems";
import locale from "./tabScripts.locale";
import { TextWidget } from "Components/optionForm";
import styles from "./tabScripts.module.css";
import classNames from "classnames";
const filterButtons = [
    {
        location: "after",
        name: "settings-button",
        options: {
            icon: "icon-search-glass text-light-on-surface-variant icon-color-inherit font-bold font-h5",
            elementAttr: {
                class: classNames(styles["filter-icon"], "no-border bg-transparent p-0")
            },
            disabled: true,
            height: 32,
            width: 32
        }
    }
];
export default function TabScripts(props) {
    const [filteredText, setFilteredText] = useState();
    useEffect(() => {
        props.onInitialized && props.onInitialized();
    }, [props.onInitialized]);
    useEffect(() => {
        !props.isExpanded &&
            props.onSetShowScriptEditorPanel &&
            props.onSetShowScriptEditorPanel(false);
    }, [props.isExpanded]);
    const handleRunScripts = useCallback((script, nodesSource) => {
        if (!props.documentObjects ||
            !props.activeDocumentId ||
            !nodesSource.length ||
            !script.Methods)
            return;
        const invalidMessage = buildRunMethodsError(props.documentObjects, map(script.Methods, method => ({ method, nodesSource })));
        if (!invalidMessage) {
            props.onRunScript && props.onRunScript(props.activeDocumentId, script.Id, nodesSource);
        }
        else {
            props.showError && props.showError(invalidMessage);
        }
    }, [props.activeDocumentId, props.documentObjects, props.onRunScript, props.showError]);
    const sidebarMenuItems = useMemo(() => {
        if (!props.data || !props.selectedNodesSource)
            return undefined;
        if (!props.selectedNodesSource.length)
            return [];
        return buildScriptSidebarItems(props.data, props.selectedNodesSource, props.readOnlyMode, props.canRunScripts ? handleRunScripts : undefined, props.canRunScripts
            ? (script) => {
                const id = `sidebarScriptMenu${script.Id}`;
                return (React.createElement(Menu, { key: "menu", popoverClassName: "dark-popover1", id: id, togglerClassName: "no-border no-default-colors animate-hover-color", togglerIconClassName: "icon-dots-vertical1", togglerWidth: ITEM_SIZES.MIN_ACTION_ELEMENT_SIZE, togglerHeight: ITEM_SIZES.MIN_ACTION_ELEMENT_SIZE, items: buildScriptActionsMenuItems(script, (item) => {
                        props.onSetShowScriptEditorPanel &&
                            props.onSetShowScriptEditorPanel(true, item, `#${props.panelId}`);
                    }, props.onDeleteScript), position: {
                        my: "right bottom",
                        at: "left bottom"
                    } }));
            }
            : undefined);
    }, [
        props.canRunScripts,
        props.readOnlyMode,
        props.data,
        props.selectedNodesSource,
        handleRunScripts,
        props.onSetShowScriptEditorPanel,
        props.onDeleteScript,
        props.panelId
    ]);
    const emptyText = isEmpty(props.selectedNodesSource)
        ? locale.SELECT_OBJECT
        : isEmpty(props.data)
            ? locale.NO_AVAILABLE_SCRIPTS
            : "";
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles["search-panel"] },
            React.createElement(TextWidget, { value: filteredText, onChange: setFilteredText, label: "\u041F\u043E\u0438\u0441\u043A", labelMode: "floating", height: 44, buttons: filterButtons })),
        React.createElement("div", { className: styles["list-container"] },
            React.createElement(SidebarMenuList, { bgColorDefault: props.bgColorDefault, bgColorActive: props.bgColorActive, inProgress: props.inProgress, sidebarMenuItems: sidebarMenuItems, emptyText: emptyText, filterText: filteredText, sortBy: props.sortBy, sortOrder: props.sortOrder, className: styles.list }))));
}
